interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
}

export const Chevron = ({
  width = 20,
  height = 20,
  hexColor = "black",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Rectangle 485"
        d="M13.4495 1.22493L7.22461 7.44987L0.999675 1.22493"
        stroke={hexColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Chevron;
